// TODO: remplacer ces types par les imports directs depuis @cs_teamwaydev/mailvista-sdk_react
// quand la nouvelle version du SDK exposera ReportBugData, CreateUserVoiceRequestData,
// SearchSimilarTicketsResult, SubmitTicketParams et InternalTicket.

export enum TicketType {
    Bug = "bug",
    UserVoice = "user_voice",
}

export type SimilarTicket = {
    id: string;
    title: string;
    description?: string;
    type: TicketType;
    status?: string;
    votes?: number;
    feature?: string;
};

export type ReportBugData = {
    bugType: "technique" | "graphique" | "fonctionnel";
    feature: string;
    title: string;
    context?: string;
    description?: string;
    isCritical?: boolean;
    aiConfidence: "partial" | "complete";
    similarTickets: SimilarTicket[];
};

export type CreateUserVoiceRequestData = {
    title: string;
    description: string;
    feature: string;
    similarTickets: SimilarTicket[];
};

/** Données du formulaire en attente de confirmation, sans les tickets similaires déjà résolus. */
export type PendingTicketFormData =
    | Omit<ReportBugData, "similarTickets">
    | Omit<CreateUserVoiceRequestData, "similarTickets">;

export type SearchSimilarTicketsResult = {
    tickets: SimilarTicket[];
    ticketType: TicketType;
    pendingFormData: PendingTicketFormData;
};

export type SubmitTicketParams = {
    title: string;
    description?: string;
    type: TicketType;
    feature?: string;
    bugType?: "technique" | "graphique" | "fonctionnel";
    context?: string;
    isCritical?: boolean;
    aiConfidence?: "partial" | "complete";
};

export type InternalTicket = {
    id: string;
    title: string;
    description?: string;
    type: TicketType;
    status: string;
    votes: number;
    feature?: string;
    bugType?: "technique" | "graphique" | "fonctionnel";
    context?: string;
    isCritical?: boolean;
    aiConfidence?: "partial" | "complete";
    userId?: string;
    createdAt: string;
    updatedAt: string;
};
